<template>
    <div>
        <ns-loader
            ref="ns-loader"
            :to-load="toLoad"
            :fetch-timer="5000"
            @dataFetched="onDataFetched"
        >
            <div slot="content">
                <MotorCard
                    v-for="(motor, index) in motors"
                    :key="index"
                    :motor="motor"
                    :is-advanced="motor.mode === 'advanced'"
                    @open-simulation-modal="openSimulationModal"
                    @refresh-data="refreshData"
                >
                </MotorCard>
                <el-dialog
                    v-if="displaySimulationModal"
                    :visible.sync="displaySimulationModal"
                    :show-close="false"
                    class="dialog"
                    title="Charger les mesures"
                    center
                    ref="newSimulationDialog"
                >
                    <Simulation
                        :motor="relatedMotor"
                        @close-simulation-modal="closeSimulationModal"
                        @refresh-data="refreshData"
                    ></Simulation>
                </el-dialog>
            </div>
        </ns-loader>
    </div>
</template>

<script>
import MotorCard from './MotorCard';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import Simulation from './simulations/Index.vue';
export default {

    name: 'Index',

    props:{
        siteUid:{
            type: String,
            required: true
        }
    },

    components:{
        MotorCard,
        NsLoader,
        Simulation
    },

    data () {
        return {
            motors: [],
            displaySimulationModal: false,
            relatedMotor: null
        };
    },

    computed:{
        toLoad(){
            return [
                {
                    name: 'motors',
                    model: 'motors',
                    filters: {
                        archived: false,
                        site_uid: this.siteUid
                    }
                },
            ];
        }
    },

    methods:{
        onDataFetched (res){
            this.$set(this, 'motors', res.motors);
        },
        openSimulationModal(relatedMotor){
            this.$set(this, 'relatedMotor', relatedMotor);
            this.$set(this, 'displaySimulationModal', true);
        },
        closeSimulationModal(){
            this.$set(this, 'relatedMotor', null);
            this.$set(this, 'displaySimulationModal', false);
        },
        refreshData(){
            this.$refs['ns-loader'].triggerRefresh();
        }
    }
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/page/Home/motors/Index.vue